import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Button, Spinner, Alert, Form,
    InputGroup
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

export default function SocieteInfos() {
    const navigate = useNavigate();
    const [societe, setSociete] = useState({
        nom: '',
        adresse: '',
        telephone: '',
        email: '',
        site_web: '',
        rc: '',
        nif: '',
        patente: ''
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        fetchSociete();
    }, []);

    const fetchSociete = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/parametres.php?action=societe',
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (!response.ok) throw new Error("Erreur chargement");
            
            const result = await response.json();
            setSociete(result.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSociete({
            ...societe,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        setSaving(true);
        setError(null);
        setSuccess(false);
        
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/parametres.php',
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        action: 'update_societe',
                        ...societe
                    })
                }
            );
            
            const result = await response.json();
            
            if (result.success) {
                setSuccess(true);
                setTimeout(() => setSuccess(false), 3000);
            } else {
                setError("Erreur lors de la sauvegarde");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" className="mb-3" style={{ width: '3rem', height: '3rem' }} />
                            <p className="text-muted">Chargement des informations...</p>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    {/* En-tête */}
                    <Row className="mb-4 fade-in">
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center header-section">
                                <div className="d-flex align-items-center gap-3">
                                    <div 
                                        className="page-icon-wrapper d-flex align-items-center justify-content-center" 
                                        style={{ 
                                            width: '70px', 
                                            height: '70px', 
                                            borderRadius: '20px',
                                            background: 'linear-gradient(135deg, rgba(67, 97, 238, 0.15), rgba(58, 86, 212, 0.15))',
                                            boxShadow: '0 10px 20px rgba(67, 97, 238, 0.15)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0
                                        }}
                                    >
                                        <i className="ri-building-line text-primary" style={{ fontSize: '36px', lineHeight: 1 }}></i>
                                    </div>
                                    <div>
                                        <h1 className="page-title mb-1" style={{ fontSize: '2rem', fontWeight: 700, color: '#1e293b' }}>
                                            Informations société
                                        </h1>
                                        <p className="page-subtitle mb-0" style={{ fontSize: '1rem', color: '#64748b' }}>
                                            Gérez les informations de votre entreprise
                                        </p>
                                    </div>
                                </div>
                                {/* <Button variant="outline-secondary" onClick={() => navigate('/parametres')} className="rounded-pill px-4">
                                    <i className="ri-arrow-left-line me-2"></i>Retour
                                </Button> */}
                            </div>
                        </Col>
                    </Row>

                    {/* Messages */}
                    {success && (
                        <Alert variant="success" className="mb-4 alert-modern">
                            <i className="ri-checkbox-circle-line me-2 fs-5"></i>
                            Informations mises à jour avec succès
                        </Alert>
                    )}
                    
                    {error && (
                        <Alert variant="danger" className="mb-4 alert-modern">
                            <i className="ri-error-warning-line me-2 fs-5"></i>
                            {error}
                        </Alert>
                    )}

                    {/* Formulaire */}
                    <Card className="border-0 shadow-sm">
                        <Card.Header className="bg-white py-3">
                            <h5 className="mb-0">
                                <i className="ri-building-line me-2 text-primary"></i>
                                Coordonnées de l'entreprise
                            </h5>
                        </Card.Header>
                        <Card.Body className="p-4">
                            <Form onSubmit={handleSubmit}>
                                <Row className="g-4">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Nom de la société</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="nom"
                                                value={societe.nom}
                                                onChange={handleChange}
                                                placeholder="Ma Société"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Site web</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="site_web"
                                                value={societe.site_web}
                                                onChange={handleChange}
                                                placeholder="www.masociete.com"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="g-4 mt-2">
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Adresse</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="adresse"
                                                value={societe.adresse}
                                                onChange={handleChange}
                                                placeholder="Adresse complète"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="g-4 mt-2">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Téléphone</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <i className="ri-phone-line"></i>
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type="text"
                                                    name="telephone"
                                                    value={societe.telephone}
                                                    onChange={handleChange}
                                                    placeholder="+241 XX XX XX XX"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Email</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <i className="ri-mail-line"></i>
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    value={societe.email}
                                                    onChange={handleChange}
                                                    placeholder="contact@masociete.com"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <hr className="my-4" />

                                <h5 className="mb-3">
                                    <i className="ri-file-copy-line me-2 text-primary"></i>
                                    Identifiants juridiques
                                </h5>

                                <Row className="g-4">
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">RC (Registre de Commerce)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="rc"
                                                value={societe.rc}
                                                onChange={handleChange}
                                                placeholder="RC123456"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">NIF (Numéro d'Identification Fiscale)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="nif"
                                                value={societe.nif}
                                                onChange={handleChange}
                                                placeholder="NIF12345678"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Patente</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="patente"
                                                value={societe.patente}
                                                onChange={handleChange}
                                                placeholder="PAT123456"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="border-top pt-4 mt-4">
                                    <Button 
                                        type="submit" 
                                        variant="primary" 
                                        className="px-5 py-2"
                                        disabled={saving}
                                        style={{
                                            background: 'linear-gradient(135deg, #4361ee, #3a56d4)',
                                            border: 'none',
                                            borderRadius: '10px'
                                        }}
                                    >
                                        {saving ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Sauvegarde...
                                            </>
                                        ) : (
                                            <>
                                                <i className="ri-save-line me-2"></i>
                                                Enregistrer
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>

                <style>{`
                    .fade-in { animation: fadeIn 0.5s ease; }
                    @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
                    .alert-modern { border-radius: 12px; border-left: 4px solid; }
                `}</style>

                <Footer />
            </div>
        </>
    );
}